import { store } from "../store";
import AppRenderer from './app_renderer';
import GARecord from './event_GArecord';
import { BOOK_CHECK_BASE_URL } from "./check_version/check_version_data";
export default class BookData {

    /**
     *
     * @type {BookData}
     * @static
     * @memberof BookData
     */
    static _instance = null;

    bookPath = "D:/testBook/"

    #bookId = "20221229798456";

    #subject = "";

    #appPath = "D:/ebook_animate";

    #bookOS = "";
    #degree = "";
    #year = "";
    #version = 1;

    /**
     * @readonly
     * @static
     * @memberof BookData
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new BookData();
        }

        return this._instance;
    }

    /**
     * 
     * 回傳書本路徑
     * @return {string} book path
     * @memberof BookData
     */
    getBookPath() {
        return this.bookPath + "/";
    }

    /**
     * 設定書本根目錄
     *
     * @param {String} path
     * @memberof BookData
     */
    setBookPath(path) {
        this.bookPath = path;
    }

    /**
     * 回傳當前書本路徑(課本、習作)
     *
     * @return {String} 
     * @memberof BookData
     */
    getNowBookPath() {
        return this.bookPath + "/content/" + store.nowBook + "/";
    }

    /**
     * 回傳A檔的路徑
     *
     * @return {String} 
     * @memberof BookData
     */
    getAFilePath() {
        return this.bookPath + "/content/file/";
    }

    /**
     * 回傳書本content的路徑
     *
     * @return {String} 
     * @memberof BookData
     */
    getBookContentPath() {
        return this.bookPath + "/content/"
    }

    /**
     * 回傳書本A檔換圖的路徑
     *
     * @return {*} 
     * @memberof BookData
     */
    getBookPicturePath() {
        return this.bookPath + "/content/picture/";
    }

    /**
     * 回傳隨堂測驗的根目錄
     *
     * @return {string} 
     * @memberof BookData
     */
    getQuestionPath() {
        return this.bookPath + "/content/question/";
    }

    /**
     * 回傳書本Id
     *
     * @readonly
     * @memberof BookData
     */
    get BookId() {
        return this.#bookId;
    }
    /**
     * 設定bookId
     * @param {String} bookId 
     */
    setBookId(bookId) {
        this.#bookId = bookId;
    }
    /**
     * 
     * @param {string} degree 
     * @param {string} os 
     * @param {string} year 
     */
    setBookData(degree, os, year) {
        this.#degree = degree;
        this.#bookOS = os;
        this.#year = year;
    }

    get bookVersion() {
        return this.#version;
    }

    /**
     * 回傳書本科別
     *
     * @readonly
     * @memberof BookData
     */
    get Subject() {
        return this.#subject;
    }
    /**
     * 設定subject
     * @param {String} subject 
     */
    setSubject(subject) {
        this.#subject = subject;
    }
    isSubjectCH = () => this.#subject == 'CH'; //國文
    isSubjectSO = () => this.#subject == 'SO'; //社會
    isSubjectEN = () => this.#subject == 'EN'; //英語
    isSubjectTE = () => this.#subject == 'TE'; //科技
    isSubjectAR = () => this.#subject == 'AR'; //藝能
    isSubjectMA = () => this.#subject == 'MA'; //數學
    isSubjectNA = () => this.#subject == 'NA'; //自然

    /**
     * 設定閱讀器啟動路徑
     *
     * @param {string} path
     * @memberof BookData
     */
    setAppPath(path) {
        this.#appPath = path;
    }

    /**
     * 回傳閱讀器路徑
     *
     * @readonly
     * @memberof BookData
     */
    get AppPath() {
        return this.#appPath;
    }

    /**
     * 回傳閱讀器相關應用程式的根目錄
     *
     * @return {string} 
     * @memberof BookData
     */
    getItemPath() {
        return this.#appPath + "/item/";
    }


    /**
     *
     *
     * @return {string} version full file name 
     * @memberof BookData
     */
    getLocalViewerVersionPath() {
        return this.#appPath + "/ebookViewer/version.json";
    }

    getOnlineBookVersionPath() {
        return BOOK_CHECK_BASE_URL + this.#degree + "/resource/" + this.#bookOS + "/" + this.#year + "/" + this.BookId + "/version.json"
    }

    async loadBookConfig() {
        const response = await fetch(this.getBookPath() + "bookConfig.json");
        const data = await response.json();

        this.setBookId(data.book_id);
        this.setBookData(data.degree, data.os, data.year);

        // console.log(this.getOnlineBookVersionPath());
        this.setSubject(data.subject);

        GARecord.Instance.bookConfigGARecord(data.book_type, data.book_year, data.book_subject, data.book_grade, data.book_name);

        AppRenderer.Instance.setBookId(data.book_id);

        if(!store.onlyRead) {
            AppRenderer.Instance.getUserRecord();
        }
        console.log("bookId:", this.BookId);
    }

    async loadBookVersion() {
        const response = await fetch(this.getBookPath() + "version.json");
        const data = await response.text();

        this.#version = data;
    }
}